import { useQuery } from "@tanstack/react-query";

import { getProjectsProjectIDJobs } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PROJECTS_QUERY_KEYS } from "./queryKeys";

const DEFAULT_LIMIT = 1000;
const DEFAULT_OFFSET = 0;

export function useProjectJobsQuery(projectId: string) {
  return useQuery({
    queryKey: PROJECTS_QUERY_KEYS.jobs(projectId),
    queryFn: processResponse(() =>
      getProjectsProjectIDJobs(projectId, DEFAULT_LIMIT, DEFAULT_OFFSET),
    ),
    enabled: !!projectId,
  });
}
